import { render, staticRenderFns } from "./SubStock.vue?vue&type=template&id=47c4e62e&scoped=true"
import script from "./SubStock.vue?vue&type=script&lang=js"
export * from "./SubStock.vue?vue&type=script&lang=js"
import style0 from "./SubStock.vue?vue&type=style&index=0&id=47c4e62e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c4e62e",
  null
  
)

export default component.exports